import React, { useEffect, useState } from "react";
import { NavLink, Link, useNavigate } from "react-router-dom";
import "./navbar.css";
import Spinner from "../Spinner";
import CustModal from "../Modal/CustModal";
import HotelInfo from "./HotelInfo";
import { getHotelPolicy } from "../../API/policyApi";

export default function Navbar( {setNavData, logo, allData , hotelPolicyData,branchDataRes }) {




  const navigate = useNavigate();
  const LoginUserType = localStorage.getItem("LoginUserType");
  const [loading,setIsLoading] =useState(false);
  const [showModal,setShowModal] = useState(false)
  const CompanyName = localStorage.getItem("branchname");
  const NavbarBgColor = allData?.headerColor || "#fff";

  const LoginAuth = localStorage.getItem("LoginAuth")?.split("_");
  const userLoggedIn =
  LoginAuth && LoginAuth[1] && LoginAuth[0] === window.location.pathname.split("/")[1];







  const handleLogOut = () => {
    setIsLoading(true);
    // localStorage.clear();
    localStorage.removeItem("fullname")
    localStorage.removeItem("LoginUserId")
    localStorage.removeItem("usertype")
    localStorage.removeItem("primaryemail")
    localStorage.removeItem("userData")
    localStorage.removeItem("Exist")
    localStorage.removeItem("LoginUserType")
    localStorage.removeItem("token")
    setTimeout(() => {
      setIsLoading(false); // Ensure loader is hidden after logout
      navigate(0)
    }, 500); // Simulate delay for logout process
  };
// console.log('setNavData::: ', setNavData);
  return (
    <div className="min_height">
      {loading && <Spinner />}
      <nav className="navbar navbar-expand-xl navbar-light p-0" style={{ background: NavbarBgColor }}>
        <div className="container nav-container-height">
          <Link className="navbar-brand nav_logo_img_container" to={`/${CompanyName}`}>
            <img
              className="logo-nav"
              src={logo || "/images/no-image.jpg"}
              alt="Logo"
              loading="lazy"
            />
            <h6>{allData?.branchname}</h6>
          </Link>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNavDropdown"
            aria-controls="navbarNavDropdown"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          <div className="collapse navbar-collapse" id="navbarNavDropdown">
            <ul className="navbar-nav ms-auto">

              {setNavData?.Home && (
                <a
                  target="_blank"
                  className="nav-link"
                  href={`https://${setNavData.Home}`}
                  rel="noopener noreferrer"
                >
                  Home
                </a>
              )}

              {(setNavData?.Rooms === "rooms" ||
                setNavData?.Services === "service" ||
                setNavData?.Events === "events" ||
                setNavData?.Class === "class" ||
                setNavData?.Booking === "booking") && (
                <NavLink className="nav-link" to={`/${CompanyName}/bookings`}>
                  Booking
                </NavLink>
              )}

              {setNavData?.Courses === "courses" && (
                <NavLink className="nav-link" to={`/${CompanyName}/courses`}>
                  Courses
                </NavLink>
              )}

              {setNavData?.Packages === "packages" && (
                <NavLink className="nav-link" to={`/${CompanyName}/packages`}>
                  Packages
                </NavLink>
              )}

              {setNavData?.["Contact Us"] === "contact-us" && (
                <NavLink className="nav-link" to={`/${CompanyName}/contactus`}>
                  Contact Us
                </NavLink>
              )}

              {setNavData?.Team === "team" && (
                <NavLink className="nav-link" to={`/${CompanyName}/appointment`}>
                  Team
                </NavLink>
              )}

              {setNavData?.["Hotel Info"] === "hotelinfo" &&
                <button className="nav-link hotel_info_btn" onClick={() => setShowModal(true)}>
                  Hotel Info
                </button>
              }


              {setNavData?.Map === "map" && (
                <Link className="nav-link" to={"/" + CompanyName + "/map"}>
                  Map
                </Link>
              )}


              {setNavData?.["Signin/Signup"] === "sign-up" && !userLoggedIn && allData?.property?.memberlogin && (
                <NavLink className="nav-link" to={`/${CompanyName}/sign-in`}>
                  Member Login
                </NavLink>
              )}

              {setNavData?.["Signin/Signup"] === "sign-up" && LoginUserType === "Prospect" && (
                <button className="nav-link" onClick={handleLogOut}>
                 Logout
                </button>
              )}





              {setNavData?.["Signin/Signup"] === "sign-up" && userLoggedIn && (
                <li className="nav-item dropdown">
                  <a
                    className="nav-link dropdown-toggle"
                    href="#"
                    id="userDropdown"
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <img
                      src="/images/user-img-login.jpg"
                      className="rounded-circle"
                      width="30"
                      alt="User"
                    />
                  </a>
                  <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="userDropdown">
                    <Link className="dropdown-item" to={`/${CompanyName}/myaccount`}>
                      My Account
                    </Link>
                    {/* {LoginUserType === "Member" &&

                    <Link className="dropdown-item" to={`/${CompanyName}/dashboard`}>
                      My Dashboard
                    </Link>

                    } */}

                    {/* {setNavData?.Courses === "courses" && (
                      <Link className="dropdown-item" to={`/${CompanyName}/mycourse`}>
                        My Courses
                      </Link>
                    )} */}
                    <button className="dropdown-item" onClick={handleLogOut}>
                      Logout
                    </button>
                  </ul>
                </li>
              )}
            </ul>
          </div>
        </div>

      </nav>
      <CustModal
        modalWidthSize={"xl"}
        show={showModal}
        footerBtn={false}
        handleClose={() => setShowModal(false)}
        title={"Hotel Information"}
        body={<HotelInfo hotelPolicyData={hotelPolicyData} branchDataRes={branchDataRes}  />}
        footerBtnName="Close"
      />



    </div>
  );
}
